import { Component, OnInit } from '@angular/core';
import { CartService } from 'src/app/_services/cart.service';
import { UserService } from 'src/app/_services';
import { QuotesService } from 'src/app/_services/quotes.service';
import { Router } from '@angular/router';
import { ClinicService } from 'src/app/_services/clinic.service';
import { ClinicProductService } from 'src/app/_services/clinic-product.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-clinic-cart',
  templateUrl: './clinic-cart.component.html',
  styleUrls: ['./clinic-cart.component.scss'],
})
export class ClinicCartComponent implements OnInit {
  cartItems: any[] = [];
  selectedCartItem: any;
  subTotal: number = 0;
  vat: number = 0.0;
  cartTotal: number = 0;
  currentUser: any;
  checkedOut: boolean = false;
  loading: boolean = false;

  cost_excl_vat: number = 0;
  cost_incl_vat: number = 0;

  constructor(
    private cartService: CartService,
    public userService: UserService,
    private quotesService: QuotesService,
    private clinicService: ClinicService,
    private router: Router,
    private clinicProductService: ClinicProductService,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.userService.getMe().subscribe((user) => {});

    const savedProduct = localStorage.getItem('sendToCart');
    if (savedProduct) {
      this.cartItems = JSON.parse(savedProduct);
      this.cost_excl_vat = this.cartItems.reduce(
        (acc, item) => acc + item.cost_excl_vat * item.total_quantity,
        0
      );
      this.cost_incl_vat = this.cartItems.reduce(
        (acc, item) => acc + item.cost_incl_vat * item.total_quantity,
        0
      );
    }
    this.cartService.updateCartItems(this.cartItems);
  }

  removeItem(index: number) {
    this.cartItems.splice(index, 1);
    localStorage.setItem('sendToCart', JSON.stringify(this.cartItems));
    this.cartService.updateCartItems(this.cartItems);

    this.cost_excl_vat = this.cartItems.reduce(
      (acc, item) => acc + item.cost_excl_vat * item.total_quantity,
      0
    );
    this.cost_incl_vat = this.cartItems.reduce(
      (acc, item) => acc + item.cost_incl_vat * item.total_quantity,
      0
    );
  }

  selectCartItem(item: any) {
    this.selectedCartItem = item;
  }

  checkOut(cartItems: any[]) {
    this.loading = true;
    cartItems = cartItems.map((item) => ({
      ...item,
      total_price: item.cost_incl_vat * item.total_quantity,
    }));

    // remove total_quantity from each item before sending to backend
    cartItems = cartItems.map(({ total_quantity, ...rest }) => rest);


    // this.loading = true;
    console.log('Checking out with items:', cartItems);

    this.clinicProductService
      .createOrder(this.cartItems[0].clinic_id,
        cartItems,
      )
      .subscribe(
        (response) => {
          this.clinicService.getCinicCredit(this.cartItems[0].clinic_id).subscribe();
          console.log('Order created successfully:', response);
          this.router.navigate(['/thankyou']);
        },
        (error) => {
          console.error('Error creating order:', error);
          this.loading = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Checkout failed. Please check your credit limit or try again.',
            key: 'checkout',
          });
        },
        () => {
          this.cartItems = [];
          localStorage.setItem('sendToCart', JSON.stringify(this.cartItems));
          this.cartService.updateCartItems(this.cartItems);
          this.checkedOut = true;
          this.loading = false;
        }
      );
  }
}
